import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics/events";
import { logError } from "@src/appV2/lib/analytics/log";
import { Component, type ErrorInfo, type ReactNode } from "react";

/**
 * Error boundary to prevent app crashes when components try to access Knock context before
 * KnockProvider is ready (e.g., during authentication).
 */
export class KnockErrorBoundary extends Component<{ children: ReactNode }, { hasError: boolean }> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  state = { hasError: false };

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    logError(APP_V2_APP_EVENTS.KNOCK_COMPONENT_ERROR_BOUNDARY, {
      error,
      metadata: {
        errorInfo,
      },
    });
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}
